import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
} from '@/components/ui/Card.tsx';
import {
  InstallmentSummaryDto,
  TransferAccountSummaryDto,
} from '@/features/public/bookingSummary/types/BookingPublicSummaryDto.ts';
import { PaymentMethod } from '@/features/dashboard/tourConfig/types/PaymentMethod.ts';
import InstallmentItem from '@/features/public/bookingSummary/components/InstallmentItem.tsx';
import TransferAccountDetails from '@/features/public/bookingSummary/components/TransferAccountDetails.tsx';
import CashInstructionInfo from '@/features/public/bookingSummary/components/CashInstructionInfo.tsx';
import NoItems from '@/components/ui/NoItems.tsx';

interface InstallmentsCardProps {
  installments: InstallmentSummaryDto[];
  orgSlug: string;
  token: string;
  transferAccounts: TransferAccountSummaryDto[];
  cashInstruction?: string;
  transactionRef: string;
}

const InstallmentsCard = ({
  installments,
  orgSlug,
  token,
  transferAccounts,
  cashInstruction,
  transactionRef,
}: InstallmentsCardProps) => {
  const hasTransfer = installments.some((i) =>
    i.allowedPaymentMethods.includes(PaymentMethod.TRANSFER),
  );
  const hasCash = installments.some((i) =>
    i.allowedPaymentMethods.includes(PaymentMethod.CASH),
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Raty i płatności</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {installments.length === 0 ? (
          <NoItems title="Brak rat do zapłaty" />
        ) : (
          installments.map((installment, index) => (
            <InstallmentItem
              key={index}
              installment={installment}
              index={index}
              orgSlug={orgSlug}
              token={token}
            />
          ))
        )}

        {hasTransfer && transferAccounts.length > 0 && (
          <TransferAccountDetails
            transferAccounts={transferAccounts}
            transactionRef={transactionRef}
          />
        )}

        {hasCash && cashInstruction && (
          <CashInstructionInfo cashInstruction={cashInstruction} />
        )}
      </CardContent>
    </Card>
  );
};

export default InstallmentsCard;
